import React, { useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import './DashboardLayout.css';
import SEO from '../../components/SEO';

function DashboardLayout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('wa_token');
    navigate('/dashboard/login', { replace: true });
  };

  useEffect(() => {
    const token = localStorage.getItem('wa_token');
    if (!token) {
      navigate('/dashboard/login', { replace: true });
    }
  }, [navigate]);

  return (
    <div className="dashboard-shell">
      <SEO title="Dashboard" noIndex canonicalPath="/dashboard" />
      <aside className="dashboard-shell-sidebar">
        <div className="dashboard-shell-brand">
          <span className="dashboard-shell-brand-mark">WA</span>
          <span className="dashboard-shell-brand-text">Dashboard</span>
        </div>

        <nav className="dashboard-shell-nav">
          <NavLink
            end
            to="/dashboard"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            Overview
          </NavLink>

          <NavLink
            to="/dashboard/branding"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            Branding
          </NavLink>

          <NavLink
            to="/dashboard/news"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            News
          </NavLink>

          <NavLink
            to="/dashboard/publications"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            Publications
          </NavLink>

          <NavLink
            to="/dashboard/navigation"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            Navigation
          </NavLink>

          <NavLink
            to="/dashboard/hero"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            Hero section
          </NavLink>

          <NavLink
            to="/dashboard/about-section"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            About section
          </NavLink>

          <NavLink
            to="/dashboard/about-us-page"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            About Us page
          </NavLink>
            
            <NavLink
            to="/dashboard/contact-page"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            Contact page
          </NavLink>    

          <NavLink
            to="/dashboard/features"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            Features
          </NavLink>

          <NavLink
            to="/dashboard/sectors"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            Sectors
          </NavLink>

          <NavLink
            to="/dashboard/services"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            Services (home)
          </NavLink>

          <NavLink
            to="/dashboard/services-page"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            Services page
          </NavLink>

          <NavLink
            to="/dashboard/testimonials"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            Testimonials
          </NavLink>

          <NavLink
            to="/dashboard/cta-banner"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            CTA banner
          </NavLink>

          <NavLink
            to="/dashboard/footer"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            Footer
          </NavLink>

          <NavLink
            to="/dashboard/contact"
            className={({ isActive }) =>
              `dashboard-shell-nav-item ${isActive ? 'is-active' : ''}`
            }
          >
            Contact page
          </NavLink>
        </nav>

        <button
          type="button"
          className="dashboard-shell-logout"
          onClick={handleLogout}
        >
          Sign out
        </button>
      </aside>

      <main className="dashboard-shell-main">
        <header className="dashboard-shell-header">
          <h1 className="dashboard-shell-title">Internal dashboard</h1>
          <p className="dashboard-shell-subtitle">
            Manage website content and track key activity here.
          </p>
        </header>

        <section className="dashboard-shell-content">
          <Outlet />
        </section>
      </main>
    </div>
  );
}

export default DashboardLayout;

